import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface UploadFileView {
  url: string;
  attachId: number;
}

export interface UploadFileDownloadEvent {
  file: UploadFileView;
}

@Component({
  selector: "app-upload-file-viewer",
  templateUrl: "./upload-file-viewer.component.html",
  styleUrls: ["./upload-file-viewer.component.scss"],
})
export class UploadFileViewerComponent {
  @Input() preview = false;
  @Input() files: UploadFileView[] = [];

  @Output() download = new EventEmitter<UploadFileDownloadEvent>();

  showPreviewModal = false;
  previewUrl: string | null = null;

  openPreviewModal(url: string) {
    if (!this.preview) return;

    this.showPreviewModal = true;
    this.previewUrl = url;
  }

  closePreviewModal() {
    if (!this.preview) return;

    this.showPreviewModal = false;
    this.previewUrl = null;
  }

  downloadFile(attachId: number) {
    this.download.emit({
      file: this.files.filter((x) => x.attachId === attachId)[0],
    });
  }

  onModalKeyDown($event) {
    if ($event.key === "Escape" || $event.key === "Esc") {
      this.showPreviewModal = false;
    }
  }

  canShowPreview(url: string) {
    return ["png", "jpeg", "jpg"].some((x) =>
      new URL(url).pathname.endsWith(x)
    );
  }
}
